import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ScriptLoaderService } from '../../_services/script-loader.service';
import { HomeService } from '../home/home.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  providers: [HomeService]
})
export class HomeComponent implements OnInit, AfterViewInit {

  constructor(
    private _homeService: HomeService,
    public _router: Router,
    private _script: ScriptLoaderService
  ) { }

  ngOnInit() {
    this.provjera();
  }

  ngAfterViewInit() {
    this._script.load('./assets/js/scripts/dashboard_visitors.js');
  }

  provjera(){
     if(!localStorage.getItem('tokenSql')){
        this._router.navigate(['/login']);
     }
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/home/home.component.ts